import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
Swiper.use([Pagination, Navigation]);

(function () {
  const projectSLider = document.querySelectorAll(".project-slider");
  let projectSwiper = [];

  for (let i = 0; i < projectSLider.length; i++) {
    projectSwiper[i] = new Swiper(projectSLider[i], {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 140,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
})();
